export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";